import { render } from "./ModalWarning.vue?vue&type=template&id=626fb3c5&scoped=true"
import script from "./ModalWarning.vue?vue&type=script&lang=js"
export * from "./ModalWarning.vue?vue&type=script&lang=js"

import "./ModalWarning.vue?vue&type=style&index=0&id=626fb3c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626fb3c5"]])

export default __exports__